/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { offerSelectionInput } from './DataActionExtension.g';
import { IrsmOfferSelectionsResponse } from './DataServiceEntities.g';

/**
 * WineClubUpsell Input Action
 */

export class WineClubUpsellInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => { return false; };
    public getCacheKey = () => `IWineClubUpsell`;
    public getCacheObjectType = () => 'IWineClubUpsell';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export type wineClubUpsell = {
    customerId: string;
    wineClubId: string;
    offerId: string;
};

export const createWineClubUpsellInput = (inputData: wineClubUpsell): WineClubUpsellInput => {
    return new WineClubUpsellInput(
        offerSelectionInput(
            inputData.customerId,
            inputData.wineClubId,
            inputData.offerId
        )
    );
};

export async function wineClubUpsellAction(input: WineClubUpsellInput, ctx: Msdyn365.IActionContext): Promise<IrsmOfferSelectionsResponse> {
    return input.input.execute(ctx);
}

export const IWineClubUpsellAction = Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IrsmOfferSelectionsResponse>>wineClubUpsellAction,
    input: createWineClubUpsellInput
});
